import { Input, SearchIcon } from '@cognite/cogs.js-v10';
import type { FC } from 'react';
import { useContext } from 'react';

import * as S from './elements';
import { SearchFilterContext } from './search-filter.context';

interface Props {
  searchPlaceholder?: string;
}

export const SearchFilter: FC<Props> = ({ searchPlaceholder }) => {
  const { useSearchQuery } = useContext(SearchFilterContext);
  const { searchQuery, setSearchQuery } = useSearchQuery();

  const handleSearchChange = (value: string) => {
    setSearchQuery(value);
  };

  return (
    <S.SearchFilterContainer>
      <Input
        type="search"
        size="large"
        variant="solid"
        fullWidth
        placeholder={searchPlaceholder}
        clearable
        icon={<SearchIcon />}
        value={searchQuery}
        onChange={(e) => {
          handleSearchChange(e.target.value);
        }}
      />
    </S.SearchFilterContainer>
  );
};
